// Splash — tela de carregamento fullscreen exibida durante a hidratação da
// sessão (AuthBootstrap). Usa LogoMark + spinner discreto. Sem dependência
// de store ou router pra poder rodar antes do bootstrap.
import { LogoMark } from '@/features/auth/pages/shared/LogoMark';
import styles from './Splash.module.css';

interface SplashProps {
  /** Texto opcional abaixo do logo (default: "Carregando sua sessão…"). */
  message?: string;
}

export function Splash({ message = 'Carregando sua sessão…' }: SplashProps) {
  return (
    <div className={styles.wrap} role="status" aria-live="polite" aria-busy="true">
      <div className={styles.center}>
        <LogoMark size={48} />
        <div className={styles.spinner} aria-hidden="true">
          <span className={styles.dot} />
          <span className={styles.dot} />
          <span className={styles.dot} />
        </div>
        <p className={styles.message}>{message}</p>
      </div>
    </div>
  );
}

export default Splash;
